import { ALIASED_LIST, CREATE_ALIASED, DELETE_ALIASED, EDIT_ALIASED } from "./apiRoutes";
import { authData } from "./Service";

export const listOfAliasedApi = async (data) => {
  const response = await authData.post(ALIASED_LIST, data);
  return response?.data;
};

export const CreateAliasedApi = async (data) => {
  const response = await authData.post(CREATE_ALIASED, data);
  return response?.data;
};

export const EditAliasedApi = async (data) => {
  const response = await authData.put(EDIT_ALIASED, data);
  return response?.data;
};

export const DeleteAliasedApi = async (id) => {
  const response = await authData.delete(`${DELETE_ALIASED}${id}`);
  return response?.data;
};
